<div class="example-container" [ngClass]="{'maxHeightCondition': manualTrigger}">
    <!--Form-->
    <form [formGroup]="issueTmplForm">
        <!--Table-->
        <table mat-table [dataSource]="issueTmplArray.controls" class="mat-elevation-z8">
            <ng-container matColumnDef="key">
                <th mat-header-cell *matHeaderCellDef>Key</th>
                <td mat-cell *matCellDef="let element"> {{element.get('key').value}} </td>
            </ng-container>

            <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef> Description </th>
                <td mat-cell *matCellDef="let element"> {{element.get('description').value}} </td>
            </ng-container>

            <ng-container matColumnDef="payload">
                <th mat-header-cell *matHeaderCellDef> Payload </th>
                <td mat-cell *matCellDef="let element;" [formGroup]="element">
                    <mat-checkbox color="primary" formControlName="isSelected"
                        (change)="checkboxChanged(element)"></mat-checkbox>
                </td>
            </ng-container>

            <ng-container matColumnDef="default">
                <th mat-header-cell *matHeaderCellDef> Value </th>
                <div class="tr-width">
                    <td mat-cell *matCellDef="let element;let i = index;" [formGroup]="element">
                        <!-- dynamic form component -->
                        <div *ngIf="!element.get('isSelected').value" class="wd-85">
                            <app-dynamic-form [input]="element" [formGroup]="element"></app-dynamic-form>
                        </div>
                        <!-- dynamic-recursive component -->
                        <div *ngIf="element.get('isSelected').value" class="wd-85">
                            <app-dynamic-dropdown [targetMenu]="'Payload'" [data]="dpService.dataMap"
                                [isRootNode]="true" [isSelect]="true" [childFormControl]="element.get('value')"
                                class="display-block" [title]="'Payload'" [placeholder]="'Select value'">
                            </app-dynamic-dropdown>
                        </div>
                    </td>
                </div>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            <!-- No data available -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan=9>
                    <app-no-data-available [newData]="getNoData"></app-no-data-available>
                </td>
            </tr>
        </table>
    </form>
</div>